module.exports = __webpack_public_path__ + "static/media/horizontal_line.2c6f09cc.svg";